import { useState } from 'react';
import { SearchTermList } from '../../../hooks/useSearchTerms';
import { ListsView } from './ListsView';
import { ListDetail } from './ListDetail';
import { HelpLink } from '../../../components/HelpLink';

const HELP_URL =
  'https://folio-accessid.zendesk.com/hc/en-us/articles/42286793380499-Adding-Bulk-Search-Term-Lists-and-Generating-Search-Reports';

export function SearchTermsTab({ projectId }: { projectId: string }) {
  const [selectedList, setSelectedList] = useState<SearchTermList | null>(null);

  return (
    <div>
      <h2>
        <i className="fas fa-search" aria-hidden="true" /> Search Terms
        {selectedList && <small> {selectedList.name}</small>}
        {' '}
        <HelpLink href={HELP_URL} testId="admin-search-terms-help-link" />
      </h2>
      {!selectedList
        ? <ListsView projectId={projectId} onOpen={setSelectedList} />
        : <ListDetail projectId={projectId} list={selectedList} onBack={() => setSelectedList(null)} />}
    </div>
  );
}
